import styled, {
  css,
  DefaultTheme,
  FlattenInterpolation,
  ThemeProps,
} from 'styled-components';
import { Flex } from 'dash-ui';

import { IContainerProps } from './Container.interfaces';

const ContainerWrapper = styled(Flex)`
  align-self: center;
  justify-content: center;
  width: 100%;
  flex-grow: 0;
`;

const ContainerStyle = styled(Flex)<{ size: 'xl' | 'lg' }>`
  background-color: ${({ theme }) => theme.colors.white};
  min-height: calc(100vh - 110px);
  box-sizing: border-box;
  max-width: ${({ theme, size }) =>
    theme.breakpoints[size] - theme.space * 10 * 2}px;

  @media ${({ theme }) => theme.devices.mobile} {
    padding-left: ${({ theme }) => theme.space * 4}px;
    padding-right: ${({ theme }) => theme.space * 4}px;
    min-height: calc(100vh - 210px);
  }
  @media ${({ theme }) => theme.devices.tablet} {
    padding-left: ${({ theme }) => theme.space * 6}px;
    padding-right: ${({ theme }) => theme.space * 6}px;
  }
`;

const Content = styled(Flex)<{
  css?: FlattenInterpolation<ThemeProps<DefaultTheme>> | string;
}>`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  box-sizing: border-box;
  ${({ css }) => css}
`;

function Container({ children, contentStyle, size = 'xl' }: IContainerProps) {
  return (
    <ContainerWrapper flexDirection="row" w="inherit">
      <ContainerStyle
        flex={1}
        px={11}
        pt={6}
        pb={4}
        flexDirection="column"
        w="100%"
        size={size}
      >
        <Content flex={1} css={contentStyle}>
          {children}
        </Content>
      </ContainerStyle>
    </ContainerWrapper>
  );
}

export default Container;
